import { ErrorHandler, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DecimalPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
//angular/prime library
import { VedraxMaterialModule } from './material/vedrax-material.module';
import { MatTableExporterModule } from 'mat-table-exporter';
//services
import { jwtInterceptorProvider } from './security/interceptors/jwt.interceptor';
import { errorInterceptorProvider } from './security/interceptors/error.interceptor';
import { VedraxErrorHandler } from './security/error/vedrax-error-handler';
import { loaderInterceptorProvider } from './security/interceptors/loader.interceptor';
import { ConfigService } from './services/config.service';
import { Configuration } from './shared/configuration';
import { VEDRAX_CONFIG } from './shared';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
//components
import { VedraxAutocompleteComponent } from './components/vedrax-autocomplete/vedrax-autocomplete.component';
import { VedraxCheckboxComponent } from './components/vedrax-checkbox/vedrax-checkbox.component';
import { VedraxChipsComponent } from './components/vedrax-chips/vedrax-chips.component';
import { VedraxControlComponent } from './components/vedrax-control/vedrax-control.component';
import { VedraxControlsComponent } from './components/vedrax-controls/vedrax-controls.component';
import { VedraxDatepickerComponent } from './components/vedrax-datepicker/vedrax-datepicker.component';
import { VedraxDynamicComponent } from './components/vedrax-dynamic/vedrax-dynamic.component';
import { VedraxFormComponent } from './components/vedrax-form/vedrax-form.component';
import { VedraxFormCardComponent } from './components/vedrax-form-card/vedrax-form-card.component';
import { VedraxFormControlComponent } from './components/vedrax-form-control/vedrax-form-control.component';
import { VedraxFormModalComponent } from './components/vedrax-form-modal/vedrax-form-modal.component';
import { VedraxInputComponent } from './components/vedrax-input/vedrax-input.component';
import { VedraxMatrixComponent } from './components/vedrax-matrix/vedrax-matrix.component';
import { VedraxNvpComponent } from './components/vedrax-nvp/vedrax-nvp.component';
import { VedraxRadioComponent } from './components/vedrax-radio/vedrax-radio.component';
import { VedraxSelectComponent } from './components/vedrax-select/vedrax-select.component';
import { VedraxTitleComponent } from './components/vedrax-title/vedrax-title.component';
import { VedraxValidationComponent } from './components/vedrax-validation/vedrax-validation.component';
import { VedraxUploadComponent } from './components/vedrax-upload/vedrax-upload.component';
import { VedraxInputFileComponent } from './components/vedrax-input-file/vedrax-input-file.component';
import { VedraxInputNumberComponent } from './components/vedrax-input-number/vedrax-input-number.component';
import { VedraxSelectAutocompleteComponent } from './components/vedrax-select-autocomplete/vedrax-select-autocomplete.component';
import { VedraxBaseComponent } from './components/vedrax-base.component';
import { VedraxLoginComponent } from './components/vedrax-login/vedrax-login.component';
import { VedraxLoaderComponent } from './components/vedrax-loader/vedrax-loader.component';
import { VedraxTableComponent } from './components/vedrax-table/vedrax-table.component';
import { VedraxTableFilterComponent } from './components/vedrax-table-filter/vedrax-table-filter.component';
import { VedraxMultipleComponent } from './components/vedrax-multiple/vedrax-multiple.component';
import { VedraxSearchAutocompleteComponent } from './components/vedrax-search-autocomplete/vedrax-search-autocomplete.component';
import { VedraxCrudComponent } from './components/vedrax-crud/vedrax-crud.component';
import { VedraxConfirmComponent } from './components/vedrax-confirm/vedrax-confirm.component';
import { MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';
import { MomentUtcDateAdapter } from './services/moment-utc-date.adapter';

@NgModule({
  declarations: [
    VedraxTableComponent,
    VedraxTableFilterComponent,
    VedraxLoaderComponent,
    VedraxLoginComponent,
    VedraxBaseComponent,
    VedraxAutocompleteComponent,
    VedraxCheckboxComponent,
    VedraxChipsComponent,
    VedraxControlComponent,
    VedraxControlsComponent,
    VedraxDatepickerComponent,
    VedraxDynamicComponent,
    VedraxFormComponent,
    VedraxFormCardComponent,
    VedraxFormControlComponent,
    VedraxFormModalComponent,
    VedraxInputComponent,
    VedraxMatrixComponent,
    VedraxNvpComponent,
    VedraxRadioComponent,
    VedraxSelectComponent,
    VedraxTitleComponent,
    VedraxValidationComponent,
    VedraxUploadComponent,
    VedraxInputFileComponent,
    VedraxInputNumberComponent,
    VedraxSelectAutocompleteComponent,
    VedraxMultipleComponent,
    VedraxSearchAutocompleteComponent,
    VedraxCrudComponent,
    VedraxConfirmComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    VedraxMaterialModule,
    MatTableExporterModule,
    RouterModule
  ],
  exports: [
    VedraxTableComponent,
    VedraxTableFilterComponent,
    VedraxLoaderComponent,
    VedraxLoginComponent,
    VedraxBaseComponent,
    VedraxAutocompleteComponent,
    VedraxCheckboxComponent,
    VedraxChipsComponent,
    VedraxControlComponent,
    VedraxControlsComponent,
    VedraxDatepickerComponent,
    VedraxDynamicComponent,
    VedraxFormComponent,
    VedraxFormCardComponent,
    VedraxFormControlComponent,
    VedraxFormModalComponent,
    VedraxInputComponent,
    VedraxMatrixComponent,
    VedraxNvpComponent,
    VedraxRadioComponent,
    VedraxSelectComponent,
    VedraxTitleComponent,
    VedraxValidationComponent,
    VedraxUploadComponent,
    VedraxInputFileComponent,
    VedraxInputNumberComponent,
    VedraxSelectAutocompleteComponent,
    VedraxMultipleComponent,
    VedraxSearchAutocompleteComponent,
    VedraxCrudComponent,
    VedraxMaterialModule,
    VedraxConfirmComponent
  ],
  providers: [
    DecimalPipe,
    jwtInterceptorProvider,
    errorInterceptorProvider,
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    { provide: DateAdapter, useClass: MomentUtcDateAdapter },
    { provide: ErrorHandler, useClass: VedraxErrorHandler },
    loaderInterceptorProvider,
    ConfigService
  ]
})
export class VedraxUiModule {
  static forRoot(configuration: Configuration): ModuleWithProviders<VedraxUiModule> {
    return {
      ngModule: VedraxUiModule,
      providers: [{ provide: VEDRAX_CONFIG, useValue: configuration }]
    };
  }
}
